import React, { Component } from "react";
import { connect } from "react-redux";
import { CognitoUser } from "amazon-cognito-identity-js";
import { Form, Button, Badge } from "react-bootstrap";

import userPool from "./UserPool";
import history from "../../history";
import Loading from "../loading";

class ResetPassword extends Component {
  state = {
    username: "",
    hasSentCode: false,
    password: "",
    confirmPassword: "",
    code: "",
    errors: {
      username: "",
      password: "",
      confirmPassword: "",
      code: "",
      cognitoError: "",
    },
    cognitoUser: null,
    confirmed: false,
  };

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
    if (this.state.errors[e.target.name]) {
      this.setState({ errors: { ...this.state.errors, [e.target.name]: "" } });
    }
  };

  onSubmitUsername = (e) => {
    e.preventDefault();
    if (this.state.username) {
      const userData = { Username: this.state.username, Pool: userPool };
      const cognitoUser = new CognitoUser(userData);
      this.setState({ cognitoUser });

      cognitoUser.forgotPassword({
        onSuccess: (data) => {
          console.log("CodeDeliveryData from forgotPassword: " + data);
        },
        onFailure: function (err) {
          alert(err.message || JSON.stringify(err));
        },
        inputVerificationCode: (data) => {
          this.setState({ hasSentCode: true, username: "" });
        },
      });
    } else {
      this.setState({
        errors: {
          ...this.state.errors,
          username: "Please enter a username to reset your password.",
        },
      });
    }
  };

  onSubmitPassword = (e) => {
    e.preventDefault();

    const { code, password, confirmPassword } = this.state;
    const resetErrors = {};

    const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{10,}/;

    if (!code) {
      resetErrors.code = "Please enter a verification code.";
    }
    if (!regExp.test(password)) {
      resetErrors.password =
        "Please enter a password with at least 12 characters, one uppercase letter, one number, and one special character. Special characters must be one of the following: ^ $ * . [ ] { } ( ) ? \" ! @ # % & / \\ , > < ' : ; | _ ~ `";
    }

    if (password !== confirmPassword) {
      resetErrors.confirmPassword = "Passwords do not match.";
    }
    this.setState({ errors: { ...this.state.errors, ...resetErrors } });

    if (password && JSON.stringify(resetErrors) === "{}") {
      this.state.cognitoUser.confirmPassword(code, password, {
        onSuccess: () => {
          this.setState({ confirmed: true });
          this.redirect = setInterval(() => history.push("/"), 3000);
        },
        onFailure: (err) => {
          this.setState({
            errors: {
              ...this.state.errors,
              cognitoError: err.message,
            },
          });
        },
      });
    }
  };

  componentWillUnmount() {
    clearInterval(this.redirect);
  }

  getUsername() {
    return (
      <Form onSubmit={this.onSubmitUsername}>
        <Form.Group>
          <Form.Label>Username or email:</Form.Label>
          <Form.Control
            type="text"
            name="username"
            placeholder="Enter username or email"
            value={this.state.username}
            onChange={this.onInputChange}
            className={this.state.errors.username ? "is-invalid" : ""}
          ></Form.Control>
          {this.state.errors.username && (
            <span className="invalid-feedback">
              {this.state.errors.username}
            </span>
          )}
        </Form.Group>
        <Button variant="primary" type="submit">
          Next
        </Button>
      </Form>
    );
  }

  reset() {
    const confMenu = (
      <Form onSubmit={this.onSubmitPassword}>
        <Form.Group>
          <Form.Label>Code:</Form.Label>
          <Form.Control
            type="text"
            name="code"
            placeholder="Enter verification code:"
            value={this.state.code}
            onChange={this.onInputChange}
            className={this.state.errors.code ? "is-invalid" : ""}
          ></Form.Control>
          <Form.Label>
            <Badge variant="secondary" className="mt-3">
              Check your email for a verification code
            </Badge>
          </Form.Label>
          {this.state.errors.code && (
            <span className="invalid-feedback">{this.state.errors.code}</span>
          )}
        </Form.Group>
        <Form.Group>
          <Form.Label>New Password:</Form.Label>
          <Form.Control
            type="password"
            name="password"
            placeholder="Enter password"
            value={this.state.password}
            onChange={this.onInputChange}
            className={this.state.errors.password ? "is-invalid" : ""}
          ></Form.Control>
          <Form.Label>
            <Badge variant="warning" className="mt-3 text-left">
              Please enter a password with at least 12 characters, one uppercase
              letter, one number, and one special character.
              <br /> Special characters must be one of the following:{" "}
              {'^ $ * . [ ] { } ( ) ? " ! @ # % & / \\ , > < \' : ; | _ ~ `"'}
            </Badge>
          </Form.Label>
          {this.state.errors.password && (
            <span className="invalid-feedback">
              {this.state.errors.password}
            </span>
          )}
        </Form.Group>
        <Form.Group>
          <Form.Label>Confirm Password:</Form.Label>
          <Form.Control
            type="password"
            name="confirmPassword"
            placeholder="Confirm password"
            value={this.state.confirmPassword}
            onChange={this.onInputChange}
            className={this.state.errors.confirmPassword ? "is-invalid" : ""}
          ></Form.Control>
          {this.state.errors.confirmPassword && (
            <span className="invalid-feedback">
              {this.state.errors.confirmPassword}
            </span>
          )}
        </Form.Group>
        {this.state.errors.cognitoError && (
          <span className="alert alert-danger d-block mx-auto mt-3">
            {this.state.errors.cognitoError}
          </span>
        )}
        <Button variant="primary" type="submit">
          Next
        </Button>
      </Form>
    );
    const confChange = (
      <div className="alert alert-success text-center">
        Password change confirmed! Redirecting to the login page...
        <br />
        <Loading />
      </div>
    );
    return this.state.confirmed ? confChange : confMenu;
  }

  render() {
    return (
      <div>{this.state.hasSentCode ? this.reset() : this.getUsername()}</div>
    );
  }
}

const mapStateToProps = (state) => {
  return { auth: state.auth };
};

export default connect(mapStateToProps)(ResetPassword);
